import api from './api';

const appointmentService = {
  getAll: async (params = {}) => {
    const response = await api.get('/appointments', { params });
    return response.data;
  },

  getCalendarView: async (start, end, userId = null) => {
    // Gleiche Quelle wie der Hauptkalender (inkl. Serientermine/Konfig-Modus) → synchron.
    // userId: Termine eines bestimmten Benutzers (wie Benutzerfilter im Hauptkalender)
    const response = await api.get('/calendar/events', {
      params: { start, end, ...(userId ? { user_id: userId } : {}) }
    });
    return response.data?.events || [];
  },

  getMyAppointments: async (userId) => {
    const params = userId ? `?user_id=${userId}` : '';
    const response = await api.get(`/appointments/my-appointments${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/appointments/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/appointments', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/appointments/${id}`, data);
    return response.data;
  },

  delete: async (id, options = {}) => {
    const params = options.deleteSeries ? '?delete_series=true' : '';
    const response = await api.delete(`/appointments/${id}${params}`);
    return response.data;
  },

  // Outlook-Synchronisation
  syncToOutlook: async (appointmentId, accountId = null) => {
    const params = accountId ? `?account_id=${accountId}` : '';
    const response = await api.post(`/appointments/${appointmentId}/sync-to-outlook${params}`);
    return response.data;
  },

  syncAllToOutlook: async (appointmentIds, accountId = null) => {
    const response = await api.post('/appointments/sync-all-to-outlook', {
      appointment_ids: appointmentIds,
      account_id: accountId
    });
    return response.data;
  },

  removeOutlookSync: async (appointmentId, deleteInOutlook = false, accountId = null) => {
    const params = new URLSearchParams();
    if (deleteInOutlook) params.append('delete_in_outlook', 'true');
    if (accountId) params.append('account_id', accountId);
    const queryString = params.toString() ? `?${params.toString()}` : '';
    const response = await api.delete(`/appointments/${appointmentId}/outlook-sync${queryString}`);
    return response.data;
  },

  // Terminkollisionen prüfen (Besichtigungsplanung)
  checkConflicts: async ({ start, end, userIds = [], excludeId = null }) => {
    const params = new URLSearchParams({ start, end });
    if (userIds.length) params.append('user_ids', userIds.join(','));
    if (excludeId) params.append('exclude_id', excludeId);
    const response = await api.get(`/appointments/check-conflicts?${params.toString()}`);
    return response.data;
  },

  // Nächsten freien Termin-Slot für einen User finden
  nextFreeSlot: async ({ durationMin = 60, fromIso = null, userId = null } = {}) => {
    const params = new URLSearchParams({ duration_min: String(durationMin) });
    if (fromIso) params.append('from_iso', fromIso);
    if (userId) params.append('user_id', userId);
    const response = await api.get(`/appointments/next-free-slot?${params.toString()}`);
    return response.data;
  },
};

export default appointmentService;
